module.exports = __webpack_public_path__ + "img/time.a9b77322.svg";